module.exports = __webpack_public_path__ + "static/media/048.6ff99ed4.wav";


/*****************
 ** WEBPACK FOOTER
 ** ./src/sound/048.wav
 ** module id = 180
 ** module chunks = 0
 **/